export default {"src":"/_next/static/media/scroll-on-icon.b4b6c15b.svg","height":137,"width":137,"blurWidth":0,"blurHeight":0};